import useInsightsSharedContext from "@/reports/teacher/utils/useInsightsSharedContext/useInsightsSharedContext";
import ReportFilterDropdown from "@/reports/components/ReportFilterDropdown";
import { Classroom } from "@/types/models/Classroom.interface";

const ClassroomFilter = () => {
  const { classrooms } = useInsightsSharedContext();

  const classroomOptions = classrooms?.map((classroom: Classroom) => {
    return {
      value: classroom.unique_id,
      label: classroom.name,
    };
  });

  const defaultOption = { value: "", label: "All Classrooms" };
  const menuOptions =
    classroomOptions.length > 0 ? [...classroomOptions] : [defaultOption];

  return (
    <ReportFilterDropdown
      menuOptions={menuOptions}
      defaultOption={defaultOption}
      label="Classroom"
      urlSearchParam="classroom"
      eventTrackingDescription="Teacher Reporting - classroom filter"
    />
  );
};

export default ClassroomFilter;
